/**
 * @generated SignedSource<<833abca00c2161aea7544b3b4292769f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useJsonLogicGetIngestionConfigBySubmissionQuery$variables = {
  submissionId?: number | null;
};
export type useJsonLogicGetIngestionConfigBySubmissionQuery$data = {
  readonly sys_submissions: ReadonlyArray<{
    readonly provider: {
      readonly ingestion_config: any | null;
      readonly provider_id: number;
      readonly provider_name: string;
    };
  }>;
};
export type useJsonLogicGetIngestionConfigBySubmissionQuery = {
  response: useJsonLogicGetIngestionConfigBySubmissionQuery$data;
  variables: useJsonLogicGetIngestionConfigBySubmissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "submissionId"
              }
            ],
            "kind": "ObjectValue",
            "name": "submission_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_submissions",
    "kind": "LinkedField",
    "name": "sys_submissions",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_providers",
        "kind": "LinkedField",
        "name": "provider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provider_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provider_name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ingestion_config",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useJsonLogicGetIngestionConfigBySubmissionQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useJsonLogicGetIngestionConfigBySubmissionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bd01ef752413d9e4ef12cecef878f415",
    "id": null,
    "metadata": {},
    "name": "useJsonLogicGetIngestionConfigBySubmissionQuery",
    "operationKind": "query",
    "text": "query useJsonLogicGetIngestionConfigBySubmissionQuery(\n  $submissionId: Int\n) {\n  sys_submissions(where: {submission_id: {_eq: $submissionId}}) {\n    provider {\n      provider_id\n      provider_name\n      ingestion_config\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e9353d53dbfa35d4b2d7c1b3e9177bc";

export default node;
